const PALETTE = ['#667eea','#764ba2','#f093fb','#4facfe','#43e97b','#fa709a','#a18cd1','#30cfd0'];

export function getInitials(user) {
  if (user.name) {
    const parts = user.name.trim().split(/\s+/);
    return parts.length > 1
      ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
      : user.name.slice(0, 2).toUpperCase();
  }
  return (user.email || '??').slice(0, 2).toUpperCase();
}

export function getAvatarColor(email) {
  let h = 0;
  for (const c of (email || '')) h = c.charCodeAt(0) + ((h << 5) - h);
  return PALETTE[Math.abs(h) % PALETTE.length];
}

function UserAvatar({ user, large = false }) {
  return (
    <div
      className={`um-avatar${large ? ' um-avatar--lg' : ''}`}
      style={{ background: getAvatarColor(user.email) }}
    >
      {getInitials(user)}
    </div>
  );
}

export default UserAvatar;
